<template>
  <div>
    <video-player :options="videoOptions" />
  </div>
</template>
<script>
import axios from "axios";
import VideoPlayer from "@/components/VideoPlayer.vue";
export default {
  components: {
    VideoPlayer
  },
  data: () => ({
    videoOptions: {
      autoplay: false,
      controls: true,
      sources: [
        {
          src: null,
          type: "video/mp4"
        }
      ]
    }
  }),

  methods: {
  }
};
</script>

<style src="video.js/dist/video-js.css">
</style>
